var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-column",staticStyle:{"width":"100%"}},[_c('CustomerPagination')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }